import client from './client';

/**
 * API functions for session management.
 */
export const sessionApi = {
  /**
   * Extends the user's session by resetting the idle timer.
   */
  extend: async (): Promise<{
    success: boolean;
    expiresAt: number;
    expiresIn: number;
  }> => {
    const response = await client.post('/session/extend');
    return response.data;
  },

  /**
   * Gets the current session status including time until timeout.
   */
  getStatus: async (): Promise<{
    active: boolean;
    lastActivityTime: number;
    expiresAt: number;
    expiresIn: number;
    warningAt: number;
    warningIn: number;
  }> => {
    const response = await client.get('/session/status');
    return response.data;
  },
};
